// extracted by mini-css-extract-plugin
module.exports = {"SurveyBody":"Survey_SurveyBody__RXacx","Body":"Survey_Body__1bNy7"};